import React from 'react';
import StoreButtons from './StoreButtons';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta-section" id="download">
      <div className="container">
        <div className="cta-content">
          <h2>Ready to Transform Your Lead Collection?</h2>
          <p>Join thousands of professionals who've made lead collection effortless with Scan2Card</p>
          
          <StoreButtons large={true} />
          
          <p className="cta-subtitle">Available for iOS and Android • Free to download</p>
        </div>
      </div>
    </section>
  );
};

export default CTA;